// extracted by mini-css-extract-plugin
module.exports = {"promo":"AddressMultichainButton_promo__EnaTd","gradient":"AddressMultichainButton_gradient__9El00","border":"AddressMultichainButton_border__hEFS4"};